export default __webpack_public_path__ + "static/media/Mihai.01273d1c.webp";